<template>
  <div class="h-screen flex flex-col bg-pitch-black text-total-white">
    <TopNavbar />
    <!-- Header Section -->
    <div class="flex w-full justify-between items-center px-4 p-3 bg-pitch-black">
      <a
        @click="goBack"
        class="text-prime-golden cursor-pointer text-lg font-medium font-avenir flex items-center"
      >
        <img
          class="w-6 h-6 inline mr-2"
          src="@/assets/images/left-chevron.svg"
          alt="Back"
        />
      </a>
      <span class="font-semibold text-2xl mr-4">Alarms</span>
      <span></span>
    </div>

    <!-- Main Content -->
    <div class="flex-1 overflow-y-auto">
      <div class="mb-6 text-left p-4">
        <h3 class="text-lg font-inter font-bold">Project</h3>
        <p class="text-base py-2">{{ projectName }}</p>
      </div>

      <div class="mb-6">
        <!-- Existing Alarms -->
        <div class="flex px-4 items-center gap-2">
          <h3 class="font-semibold text-lg">Existing Alarms</h3>
          <button @click="addAlarm" class="text-prime-golden text-lg">
            <i class="fas fa-plus"></i>
          </button>
        </div>

        <!-- Alarm List -->
        <div class="mt-2 px-4">
          <!-- If loading -->
          <p v-if="simulationStore.loadingAlarms" class="text-md mt-4 text-gray-400">
            Loading alarms...
          </p>
          <!-- If an error occurred -->
          <p v-else-if="simulationStore.error" class="text-md mt-4 text-deep-rust">
            {{ simulationStore.error }}
          </p>
          <!-- If no alarms -->
          <p
            v-else-if="simulationStore.alarms.length === 0"
            class="text-md text-total-white-500 mt-4"
          >
            No alarms to show!
          </p>
          <!-- Otherwise, list them -->
          <ul v-else>
            <li
              v-for="alarm in simulationStore.alarms"
              :key="alarm.id"
              class="flex justify-between items-center py-3 px-6 bg-eerie-black-500 border-b border-light-grey-translucent-800"
            >
              <p class="text-sm">
                {{ formatAlarmDatetime(alarm.alarm_datetime) }}
              </p>
              <!-- <button @click="deleteAlarm(alarm.id)" class="text-prime-golden">
                <img src="@/assets/images/trash-icon.svg" alt="Delete" class="w-5 h-5" />
              </button> -->
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from "@/components/TopNavbar.vue";
import { useSimulationStore } from "@/stores/simulation";
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";

export default {
  components: { TopNavbar },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const simulationStore = useSimulationStore();
    const toast = useToast();

    const projectId = route.params.id;
    const projectName = route.query.projectName || "Untitled Project";

    // Fetch alarms with error handling
    onMounted(async () => {
      try {
        await simulationStore.fetchAlarms(projectId);
      } catch (err) {
        simulationStore.error = "Failed to load alarms. Please try again later.";
        console.error("Error fetching alarms:", err);
        toast.error("Failed to load alarms.");
      }
    });

    function goBack() {
      if (route.query.tab) {
        router.push({
          name: "ProjectPage",
          params: {
            id: route.query.projectId || route.params.projectId || route.params.id,
          },
          query: { tab: route.query.tab, readLogs: route.query.readLogs },
        });
      } else {
        router.go(-1);
      }
    }

    const addAlarm = () => {
      router.push({
        name: "CreateAlarmPage",
        params: { id: projectId },
        query: { projectName },
      });
    };

    const deleteAlarm = (alarmId) => {
      simulationStore.alarms = simulationStore.alarms.filter((a) => a.id !== alarmId);
    };

    function formatAlarmDatetime(datetimeString) {
      if (!datetimeString) return "";
      return new Date(datetimeString).toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
        weekday: "short",
      });
    }

    return {
      projectName,
      simulationStore,
      formatAlarmDatetime,
      goBack,
      addAlarm,
      deleteAlarm,
    };
  },
};
</script>

<style scoped></style>
